import {Swiper, Navigation, Pagination, Keyboard, Autoplay, EffectFade} from "swiper"
import {SwiperOptions} from "swiper/types/swiper-options"

Swiper.use([Navigation, Pagination, Keyboard, Autoplay, EffectFade])

const sliderSections = document.querySelectorAll(".fade-in-section")

sliderSections.forEach((slideSection) => {
  const slider = slideSection.querySelector(".fade-in-section__slider") as HTMLElement
  // const buttonPrev = slideSection.querySelector(".swiper-button-prev");
  // const buttonNext = slideSection.querySelector(".swiper-button-next");

  const swiperSettings: SwiperOptions = {
    effect: "fade",
    fadeEffect: {
      crossFade: true
    },
    loop: true,
    keyboard: true,
    slidesPerView: "auto",
    // spaceBetween: 8,
    updateOnWindowResize: true,
    // loop: true,
    // loopedSlides: 2,
    speed: 2000,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    // breakpoints: {
    //     767: {
    //         spaceBetween: 16
    //     },
    //
    // }
  }

  new Swiper(slider, swiperSettings)
})
